import React from 'react';
import Header from 'containers/SignupPages/Header';
import Form from 'containers/SignupPages/VerifyIdentity/Form';
import { IntlShape, injectIntl } from 'react-intl';
import { translate } from 'helpers/intl';
import get from 'lodash/get';
import messages from 'containers/SignupPages/VerifyIdentity/messages';
import { PERSONAL_INFO } from '../constants';

const VerifyIdentity = (props: VerifyIdentityType) => {
  return (
    <>
      <Header
        title={translate(get(messages, 'title'), props)}
        subTitle={translate(get(messages, 'subTitle'), props)}
      />
      <Form
        isLoading={props.isLoading}
        onClickPrevious={() => {
          props.setSignupStep(PERSONAL_INFO);
        }}
        onSubmitStep={props.onSubmitStep}
      />
    </>
  );
};

export type VerifyIdentityType = {
  setSignupStep: Function;
  onSubmitStep: Function;
  isLoading: boolean;
  intl: IntlShape;
};

export default injectIntl(VerifyIdentity);
